import React from 'react';
import PropTypes from 'prop-types';
import { prismicImage } from 'src/common/utils/prismic-image';
import cx from 'classnames';
import RichText from '../../Prismic/RichText';
import { RightArrow } from '../../SVGs';
import './Product.scss';
import Price from '../../Price';

const Product = props => (
  <div className={cx('product-wrapper', {
    'product-wrapper--has-badge': props.showBadge !== 'false' && !!props.badgeContent
  })}>
    <a href={props.link} className="product-link">
      <div
        className="product"
        style={{ borderColor: props.badgeBackgroundColor }}>
        {props.showBadge !== 'false' && props.badgeContent &&
          <div className="product-badge" style={{ backgroundColor: props.badgeBackgroundColor, color: props.badgeContentColor }}>
            {props.badgeContent}
          </div>
        }
        <div className="product-image-wrapper" style={{ backgroundColor: props.imageBackgroundColor }}>
          <img src={prismicImage(props.image)} alt="" className="product-image" />
        </div>
        <div className={cx('product-content', {
          'product-content--show-product-tag': props.showProductTag
        })}>
          <h5 className="text-kilo product-card-title">{props.title}
            <span className="arrow-right">{props.showArrow && <RightArrow />}</span>
          </h5>
          {props.showDescription !== false && props.description &&
            <RichText className="product-content-text" fields={props.description} />
          }
        </div>
        {props.productTags && props.showProductTag && (
          <div className="product-tags">
            {props.productTags.map((tag, idx) => (
              <span
                key={idx}
                className="product-tag"
                style={{
                  backgroundColor: tag.backgroundColor,
                  color: tag.textColor ? tag.textColor : 'white'
                }}>
                {tag.label}
              </span>
            ))}
          </div>
        )}
        {props.showPrice !== false && props.price &&
          <div className="product-info">
            <p className="age">{props.age}</p>
            <Price price={props.price} priceString={props.showPrice !== false && props.productPriceLabel} savings={props.savings} savingsType="slash" />
          </div>
        }
      </div>
    </a>
  </div>
);

Product.propTypes = {
  link: PropTypes.string.isRequired,
  badgeContent: PropTypes.string,
  badgeContentColor: PropTypes.string,
  badgeBackgroundColor: PropTypes.string,
  image: PropTypes.object.isRequired,
  imageBackgroundColor: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.array,
  ]).isRequired,
  age: PropTypes.string.isRequired,
  price: PropTypes.object.isRequired,
  productPriceLabel: PropTypes.string,
  savings: PropTypes.object,
  showBadge: PropTypes.string,
  showArrow: PropTypes.bool,
  showDescription: PropTypes.bool,
  showPrice: PropTypes.bool,
  productTags: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      backgroundColor: PropTypes.string
    })),
  showProductTag: PropTypes.bool
};

export default Product;



// WEBPACK FOOTER //
// ./src/client/js/view/components/ProductListII/Product/Product.js